import * as types from '../mutation-types';
import api from '../../helpers/api';

export default {
  state: {
    all: [],
  },
  getters: {
    getGalleries: (state) => state.all,
    getGallery: (state) => state.all[0],
  },
  actions: {
    async getAllGalleries({ commit }) {
      const galleries = await api.get('galleries');
      commit(types.RECEIVED_GALLERIES, { galleries });
    },
    async getGallery({ commit }, GalleryId) {
      const gallery = await api.get(`galleries/${GalleryId}`);
      commit(types.RECEIVED_GALLERY, { gallery });
    },
  },
  mutations: {
    [types.RECEIVED_GALLERY](state, { gallery }) {
      let match;
      // eslint-disable-next-line no-cond-assign
      if (match = state.all.find((gal) => gal.id === gallery.id)) {
        Object.assign(match, gallery);
      } else {
        state.all.push(gallery);
      }
    },
    [types.RECEIVED_GALLERIES](state, { galleries }) {
      state.all = galleries;
    },
  },
};
